import { useEffect, useRef, useState } from 'react';
import styles from './timePicker.module.css';
import { ReactComponent as DropdownArrowDown } from '../../assets/icons/dropdownArrowDown.svg';
import { ReactComponent as DropdownUpArrow } from '../../assets/icons/dropdownArrowUp.svg';

const parseTime = (time) => {
    if (!time) return { h: '09', m: '00', p: 'AM' };
    const [timePart, period] = time.split(' ');
    const [hours, minutes] = timePart.split(':');
    return { h: hours, m: minutes, p: period };
};

const TimePicker = ({ value, onChange, placeholder = 'Select Time', error }) => {
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const initial = parseTime(value);

    const [hours, setHours] = useState(initial.h);
    const [minutes, setMinutes] = useState(initial.m);
    const [period, setPeriod] = useState(initial.p);
    const selectedTime = `${hours}:${minutes} ${period}`;

    const HOURS = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));
    const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));
    const PERIODS = ['AM', 'PM'];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const { h, m, p } = parseTime(value);
        setHours(h);
        setMinutes(m);
        setPeriod(p);
    }, [value]);

    return (
        <div className={`${styles.timePicker} ${error ? 'error-highlight' : ''}`} ref={dropdownRef}>
            <div className={styles.timePickerDiv} onClick={() => setIsOpen((prev) => !prev)}>
                <span>{value || <span className={styles.placeholder}>{placeholder}</span>}</span>
                {isOpen ? <DropdownUpArrow /> : <DropdownArrowDown />}
            </div>
            {isOpen && (
                <div className={styles.timePickerDropdownContentContainer}>
                    <div className={styles.wheelGroup}>
                        <h3>Hours</h3>
                        <div className={styles.wheel}>
                            {HOURS.map((hour) => (
                                <div
                                    key={hour}
                                    className={`${styles.wheelItem} ${hours === hour ? styles.active : ''}`}
                                    onClick={() => {
                                        const newTime = `${hour}:${minutes} ${period}`;
                                        setHours(hour);
                                        onChange?.(newTime);
                                    }}
                                >
                                    {hour}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles.wheelGroup}>
                        <h3>Minutes</h3>

                        <div className={styles.wheel}>
                            {MINUTES.map((minute) => (
                                <div
                                    key={minute}
                                    className={`${styles.wheelItem} ${minutes === minute ? styles.active : ''}`}
                                    onClick={() => {
                                        const newTime = `${hours}:${minute} ${period}`;
                                        setMinutes(minute);
                                        onChange?.(newTime);
                                    }}
                                >
                                    {minute}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles.wheelGroup}>
                        <h3>Period</h3>

                        <div className={styles.wheel}>
                            {PERIODS.map((p) => (
                                <div
                                    key={p}
                                    className={`${styles.wheelItem} ${period === p ? styles.active : ''}`}
                                    onClick={() => {
                                        const newTime = `${hours}:${minutes} ${p}`;
                                        setPeriod(p);
                                        onChange?.(newTime);
                                    }}
                                >
                                    {p}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TimePicker;
